import { createCache, makeSwapperAxiosServiceMonadic } from '../../../utils';
const maxAge = 5 * 1000; // 5 seconds
const cachedUrls = [];
const axiosConfig = {
    timeout: 10000,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    baseURL: 'https://bs-router-v3.chainservice.io',
};
const butterServiceBase = createCache(maxAge, cachedUrls, axiosConfig);
export const butterService = makeSwapperAxiosServiceMonadic(butterServiceBase);
